
import { Component, Vue } from 'vue-property-decorator'

/**
 * tdタグの基底コンポーネント
 */
@Component
export default class TableData extends Vue {}
